import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { ClientWorkOrder, ClientWorkOrderDetails } from '../types';

export const getClientWorkOrderById = async (id: string): Promise<ClientWorkOrderDetails> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/client-work-order/${id}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as ClientWorkOrderDetails;
  return response;
};
